// extracted by mini-css-extract-plugin
export default {"box":"AgentForm_box__xopUh","textArea":"AgentForm_textArea__uTitk"};